import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { DocumentEditor } from "../document/DocumentEditor";
import { FileText, Edit2, Download } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useDocxExport } from "@/hooks/useDocxExport";
interface Document {
  id: string;
  title: string;
  content: string;
}
interface DocumentViewDialogProps {
  document: Document | null;
  isEditing: boolean;
  editedContent: string;
  onClose: () => void;
  onEdit: () => void;
  onSave: () => void;
  onContentChange: (content: string) => void;
}
export const DocumentViewDialog = ({
  document,
  isEditing,
  editedContent,
  onClose,
  onEdit,
  onSave,
  onContentChange
}: DocumentViewDialogProps) => {
  const {
    exportToDocx
  } = useDocxExport();
  if (!document) return null;
  const handleExportDOCX = async () => {
    await exportToDocx(document.content, document.title);
  };
  return <Dialog open={!!document} onOpenChange={onClose}>
      <DialogContent className="w-[95vw] max-w-4xl h-[90vh] flex flex-col p-0 gap-0 rounded-xl">
        <DialogHeader className="px-4 py-2 md:p-6 border-b">
          <DialogTitle className="text-primary flex items-center gap-2">
            <FileText className="w-5 h-5" />
            {isEditing ? "Editar Documento" : "Visualizar Documento"}
          </DialogTitle>
        </DialogHeader>
        
        <ScrollArea className="flex-1">
          <div className="p-4 md:p-6">
            {isEditing ? <DocumentEditor content={editedContent} onSave={onSave} onCancel={onClose} onChange={onContentChange} /> : <div className="h-full flex flex-col">
                <div id="document-content" className="bg-white rounded-lg shadow-sm mx-auto p-8">
                  <div className="prose max-w-none" dangerouslySetInnerHTML={{
                __html: document.content
              }} />
                </div>
              </div>}
          </div>
        </ScrollArea>

        {!isEditing && <div className="border-t p-4 md:p-6 bg-white">
            <div className="flex flex-col sm:flex-row justify-end gap-2">
              
              <Button onClick={handleExportDOCX} className="w-full sm:w-auto bg-primary hover:bg-primary/90 text-white flex items-center justify-center gap-2">
                <Download className="w-4 h-4" />
                <span>Exportar DOCX</span>
              </Button>
              <Button onClick={onClose} variant="outline" className="w-full sm:w-auto">
                Fechar
              </Button>
            </div>
          </div>}
      </DialogContent>
    </Dialog>;
};